import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/invoices'

// Define invoices module
const invoices = {
  state: {
    data: {},
    errors: {}
  },
  mutations: {
    setInvoicesErrors (state, payload) {
      state.errors = payload
    }
  },
  actions: {
    async invoicesStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setInvoicesErrors', error.response.data)
      }
    },
    async invoicesStoreBulk ({ commit }, payload) {
      try {
        const response = await axios.post(`${BASE_URL}/bulk`, payload)
        if (response.status === 201) {
          return response.data
        }
      } catch (error) {
        commit('setInvoicesErrors', error.response.data)
      }
    },
    async invoicesUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setInvoicesErrors', error.response.data)
      }
    },
    async invoicesDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload.id}`, payload.id)
        if (response.status === 204) {
          commit('deleteInvoiceData', payload)
        }
      } catch (error) {
        commit('setInvoicesErrors', error)
      }
    },
    async fetchAvailableInvoicesNumber ({ commit }, payload) {
      try {
        const response = await axios.post(`${BASE_URL}/bulk/report`, {
          id: parseInt(payload)
        })
        if (response.status === 200) {
          return response.data.data
        }
      } catch (error) {
        commit('setInvoicesErrors', error.response.data)
      }
    }
  }
}

// Export the invoices module
export default invoices
